import React, { useState, useEffect } from 'react';
import './Sidebar.css';
import dummyProfile from '../../assets/dummyprofile.png';
// import logo from '../../assets/logo-transparent-png.png';
import { Dropdown, Menu } from "antd";
import { MdOutlineDashboard } from "react-icons/md";
import { TbReportAnalytics } from "react-icons/tb";
import { AiOutlineUser, AiOutlineLogout } from "react-icons/ai";
import { FiMessageSquare, FiFolder } from "react-icons/fi";
import { BiChevronDown } from "react-icons/bi";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState("");
  const [activeMenu, setActiveMenu] = useState(""); 
  const [userRole, setUserRole] = useState(null); 
  const location = useLocation();
  const [userName, setUserName] = useState(''); 
  const user = JSON.parse(localStorage.getItem("user"));

  // Retrieve user role from localStorage on mount
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setUserRole(user.role);
      setUserName(user.firstname);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth > 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };

  const handleSubmenuToggle = (menuName) => {
    setOpenSubmenu((prev) => (prev === menuName ? "" : menuName));
  };

  const handleMenuClick = (menuName) => {
    setActiveMenu(menuName); // Set the active menu when clicked
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  const profileMenu = (
    <Menu>
      <Menu.Item key="1">
        <Link to="/changePassword">Change Password</Link>
      </Menu.Item>
      <Menu.Item key="2" onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  const menus = [
    { name: "Dashboard", link: "/dashboard", icon: MdOutlineDashboard, role: ["SUPERADMIN", "MANAGER", "CONCIERGE"] },
    {
      name: "Employee's",
      link: "#",
      icon: AiOutlineUser,
      role: ["MANAGER", "SUPERADMIN"],
      submenu: [
        { name: "Add Employee", link: "/employeeform", role: ["MANAGER", "SUPERADMIN"] },
        { name: "Managers", link: "/viewManagers", role: ["SUPERADMIN"] },
        { name: "Concierge", link: "/viewConcierge", role: ["MANAGER", "SUPERADMIN"] },
      ],
    },
    {
      name: "Visitors",
      link: "#",
      icon: FiMessageSquare,
      role: ["MANAGER", "SUPERADMIN", "CONCIERGE"],
      submenu: [
        { name: "Add Visitors", link: "/visitorform", role: ["MANAGER", "SUPERADMIN", "CONCIERGE"] },
        { name: "View Visitors",   link: user?.role === "SUPERADMIN" ? "/viewVisitors" : "/viewManagerVisitors", role: ["MANAGER", "SUPERADMIN", "CONCIERGE"] },
        { name: "Time-In Visitors", link: user?.role === "SUPERADMIN" ? "/timeInVisitors" : "/viewManagerTimeInVisitors", role: ["MANAGER", "SUPERADMIN", "CONCIERGE"] },
        { name: "Time-Out Visitors",  link: user?.role === "SUPERADMIN" ? "/timeOutVisitors" : "/viewManagerTimeOutVisitors", role: ["MANAGER", "SUPERADMIN", "CONCIERGE"] },
      ],
    },
    {
      name: "Sites", 
      link: "#",
      icon: TbReportAnalytics,
      role: ["SUPERADMIN"],
      submenu: [
        { name: "Add Sites", link: "/siteform", role: ["SUPERADMIN"] },
        { name: "View Sites", link: "/viewsites", role: ["SUPERADMIN"] },
      ],
    },
    {
      name: "Visitor Types",
      link: "#",
      icon: FiFolder,
      role: ["SUPERADMIN"],
      submenu: [{ name: "View Visitor Types", link: "/viewvisitortypes", role: ["SUPERADMIN"] }],
    },
    { name: "Log Out", link: "", icon: AiOutlineLogout, role: ["MANAGER", "SUPERADMIN", "CONCIERGE"] },
  ];

  return (
    <>
      {/* Header */}
      <header className="header">
 
                {/* <div className='logo'>
          <div className="logo-section">
            <img src={logo} alt="logo" className="logo-pic" /> 
          </div>
        </div>   */}
        
        <button
          className="hamburger"
          onClick={toggleSidebar}
          aria-label="Toggle sidebar"
        >
          ☰
        </button>



        <div className="profile-section">
          <Dropdown overlay={profileMenu} trigger={['click']}>
            <div className="profile-dropdown">
              <img src={dummyProfile} alt="Profile" className="profile-pic" />
              <span className="profile-name">{userName}</span>
            </div>
          </Dropdown>
        </div>
      </header>



      {/* Sidebar */}
      <aside className={`sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
        <div className="menu">
          {menus.map((menu, i) =>
            // Show menu item only if user's role is included in the menu's allowed roles
            menu.role.includes(userRole) && (
              <div key={i}>
                <Link
                  to={menu.link}
                  className={`menu-item ${menu.submenu ? "has-submenu" : ""} ${
                    activeMenu === menu.name || location.pathname === menu.link ? "active" : ""
                  }`}
                  onClick={() => {
                    handleMenuClick(menu.name);
                    if (menu.submenu) {
                      handleSubmenuToggle(menu.name);
                    } else if (menu.name === "Log Out") {
                      handleLogout();
                    }
                  }}
                >
                  <div className="icon">{React.createElement(menu.icon, { size: 20 })}</div>
                  <span className={`menu-name ${!isSidebarOpen ? "hidden" : ""}`}>
                    {menu.name}
                  </span>
                  {menu.submenu && (
                    <BiChevronDown
                      className={`arrow ${openSubmenu === menu.name ? "open" : ""}`}
                    />
                  )}
                </Link>
                {menu.submenu && openSubmenu === menu.name && isSidebarOpen && (
                  <div className="submenu">
                    {menu.submenu.map((subItem, j) =>
                      subItem.role.includes(userRole) ? (
                        <Link
                          to={subItem.link}
                          key={j}
                          className={`submenu-item ${
                            location.pathname === subItem.link ? "active" : ""
                          }`}
                          onClick={() => handleMenuClick(subItem.name)}
                        >
                          {subItem.name}
                        </Link>
                      ) : null
                    )}
                  </div>
                )}
              </div>
            )
          )}
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
